export const unicodeNormalization = (string: string): string =>
  string
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
